import { render } from "./AddBlacklistModal.vue?vue&type=template&id=5d344114&ts=true"
import script from "./AddBlacklistModal.vue?vue&type=script&lang=ts"
export * from "./AddBlacklistModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__